import { render, staticRenderFns } from "./DialogUpdateDelivered.vue?vue&type=template&id=4f97ef86&"
import script from "./DialogUpdateDelivered.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports